export default {
  devTitle: 'EMMA LEE',
  index: '主页',
  info: '走进逸达',
  companyphilosophy: '企业理念',
  companyCulture: '企业文化',
  productService: '产品服务',
  freightReservation: '两岸货运预约',
  valueAdd: '增值服务',
  customerCenter: '客户专区',
  reserve: '我要预约',
  checkList: '我要查单',
  freightInquiry: '运费查询',
  commonProblem: '常见问题',

  // Main
  customerService: '客户服务：400-333-339',

  // Index
  freightQuery: '货运单号查询',
  'placeholder-number': '请输入快件单号',
  search: '开始查询',
  waybillNumber: '运单号',
  departure: '出发地',
  destination: '目的地',
  pieces: '件数',
  status: '状态',
  deliveryTime: '送达时间',
  recipient: '签收人',
  date: '日期时间',
  detail: '详细',

  // 置底用
  aaa: 'aaa'
}
